import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const attachmentTypeApi = createApi({
  reducerPath: 'attachmentTypeApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/api/v1/attachment_types' }),
  endpoints: (builder) => ({
    getAttachmentTypes: builder.query({
      query: (searchParams = '') => searchParams
    }),
    getAttachmentType: builder.query({
      query: (id) => `/${id}`,
      transformResponse: (response) => response
    })
  })
})

const { useGetAttachmentTypesQuery, useGetAttachmentTypeQuery } = attachmentTypeApi
export {
  attachmentTypeApi,
  useGetAttachmentTypesQuery,
  useGetAttachmentTypeQuery
}
